import { MoreVertical, Plus } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { DataTableRowActions } from "../modal/row-actions";
import Pagination from "@/components/ui/table/pagination-table";
import { useMemo, useState } from "react";
import MembershipExpiryForm from "../modal/membership-expiry-form";
import { useGetEmailTriggersQuery, useUpdateEmailTriggerMutation } from "@/services/systemConfigApi";
import { EmailTrigger } from "@/types/system-setting/system-config";
import { toast } from "@/components/ui/use-toast";

interface ReminderItem {
  id: number;
  trigger: string;
  emailTemplate: string;
  status: boolean;
}


const MembershipExpiry = () => {
  const [isOpen, setOpen] = useState(false);
  const [action, setAction] = useState<"add" | "edit">("add");
  const [data, setData] = useState<EmailTrigger | undefined>(undefined);

  const [updateEmailTrigger] = useUpdateEmailTriggerMutation()


  const handleEdit = (data: EmailTrigger) => {
    console.log("Edit notification:", data);
    setAction("edit");
    setData(data);
    setOpen(true);
    // Add your edit logic here
  };

  const { data: reminderItemData, refetch } = useGetEmailTriggersQuery({
    query: "include_keys=membership_cancellation",
  })

  const membershipCancellation = useMemo(() => {
    return Array.isArray(reminderItemData?.data)
      ? reminderItemData?.data
      : [];
  }, [reminderItemData])

  const handleToggle = async (enabled: boolean) => {
    const payload = {
      ...membershipCancellation[0],
      is_active: enabled,
    }
    try {
      const resp = await updateEmailTrigger(payload).unwrap();
      if (resp) {
        toast({
          variant: "success",
          title: `Expiry  ${enabled ? "enabled" : "disabled"} successfully.`,
        })
        refetch();
      }
    } catch (error) {
      console.error('Failed to update trigger:', error);
    }
  };




  return (
    <div className="p-4 mx-auto border-[1px] border-gray-200 rounded-md">
      <div className="flex items-center justify-between  mb-4">
        <div className="flex items-center gap-2">
          <h2 className="text-lg font-medium">Membership Expiry Reminder</h2>
          {/* <span className="text-sm text-muted-foreground bg-green-100 px-2 rounded">
            0/4
          </span> */}
        </div>

      </div>

      <div className="space-y-3">
        {membershipCancellation.length > 0 ? (
          <div
            key={membershipCancellation[0].id}
            className="border rounded-lg px-3 py-2 hover:border-green-500/50 transition-colors"
          >
            <div className="flex items-start justify-between">
              <div className=" flex-1">
                <div className="flex items-center justify-between">
                  <div className="flex flex-col items-start h-12  justify-between ">
                    <p className="flex gap-2">
                      <span className="text-sm font-medium">Trigger:</span>
                      <span className="text-sm text-green-500">
                        {membershipCancellation[0]?.no_of_days_before} Days - <span className="capitalize">{membershipCancellation[0]?.trigger_name || 'N/A'}</span>
                      </span>
                    </p>

                    <div className="flex gap-2">
                      <span className="text-sm font-medium tex">Email Subject:</span>
                      <span className="text-sm text-muted-foreground">
                        {membershipCancellation[0]?.email_subject || 'N/A'}
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col justify-end items-end gap-2">
                    <button
                      type="button"
                      title="Edit"
                      onClick={() => handleEdit(membershipCancellation[0])}
                      className="flex items-center gap-2 px-3 py-1 text-sm font-medium text-primary  rounded-md  transition-colors"
                    >
                      <i className="fa fa-pencil"></i>
                    </button>
                    <div className="flex items-center gap-2">
                      <span className="text-sm">Status</span>
                      <Switch checked={membershipCancellation[0]?.is_active || false} onCheckedChange={(value) => {
                        handleToggle(value)
                      }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center text-muted-foreground">No reminders found</div>
        )}
      </div>
      <MembershipExpiryForm
        editModeData={data}
        isOpen={isOpen}
        setOpen={setOpen}
        action={action}
        setAction={setAction}
        refetch={refetch}
      />
    </div>
  );
};

export default MembershipExpiry;


